/**
 * createServiceRequest — 外部依赖服务请求工厂
 *
 * 用法（参考集成开发-添加依赖应用.md §5.2）：
 *
 *   const crmRequest = createServiceRequest('crm');
 *   export async function queryCustomers(params: QueryParams) {
 *     return crmRequest<QueryResult>('/bff/zy-crm/customers', { method: 'GET', params });
 *   }
 *
 * 鉴权注意：Authorization、x-tenant-uuid、x-organization-uuid 头已由
 * src/requestErrorConfig.ts 中的 requestInterceptors 全局注入，
 * 此处无需重复处理。
 *
 * dev 环境：将 UMI_APP_<SERVICE>_API_URL 留空，配合 config/proxy.ts 中的
 * 专属代理规则，请求自动走 devProxy；prod 环境填写完整服务 URL，直连。
 */
import { BizAppConfig } from 'config/application.manifest';
import { createRequest } from '@/services/request';

type ServiceKey = keyof (typeof BizAppConfig)['services'];

export function createServiceRequest(serviceKey: ServiceKey) {
  const config = BizAppConfig.services[serviceKey];
  const baseUrl = config.baseUrl ?? '';
  const basePath = config.basePath ?? '';
  const inner = createRequest(baseUrl);

  return <T = unknown>(
    path: string,
    options?: Parameters<ReturnType<typeof createRequest>>[1],
  ): Promise<T> => inner<T>(`${basePath}${path}`, options);
}
